/**
 * Shared IndexedDB connection for the Cashier PWA.
 * Stores: 'auth' (token) + 'action-queue' (offline request queue).
 */

export const DB_NAME = 'tkf-cashier'
export const DB_VERSION = 1

export const STORES = {
  AUTH: 'auth',
  QUEUE: 'action-queue',
} as const

let _db: Promise<IDBDatabase> | null = null

export function openCashierDb(): Promise<IDBDatabase> {
  if (_db) return _db
  _db = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = (e) => {
      const db = (e.target as IDBOpenDBRequest).result
      if (!db.objectStoreNames.contains(STORES.AUTH)) {
        db.createObjectStore(STORES.AUTH)
      }
      if (!db.objectStoreNames.contains(STORES.QUEUE)) {
        db.createObjectStore(STORES.QUEUE, { keyPath: 'uuid' })
      }
    }
    req.onsuccess = (e) => resolve((e.target as IDBOpenDBRequest).result)
    req.onerror = (e) => reject((e.target as IDBOpenDBRequest).error)
  })
  return _db
}

// Called in tests before each case to get a clean DB. Closes the cached
// connection first so a subsequent indexedDB.deleteDatabase() isn't left
// 'blocked' by a still-open handle (which would silently no-op the delete
// and leak records into the next test).
export async function resetDbForTesting(): Promise<void> {
  if (_db) {
    const db = await _db
    db.close()
  }
  _db = null
}
